<template>
  <page-header>
    <h2>Новости</h2>  
    <template #actions>
      <div class='d-flex align-items-baseline actions'>
        <button-component kind="tertiary" :class="{filtered: isFiltered}" @click="modals.filter = !modals.filter">
          <template #prepend>
            <icon-component class="mr-2" name="filter"/>
          </template>
          Фильтр
        </button-component>
      </div>
    </template>
  </page-header>  

  <section class="content">    
    <template v-if="page.items?.length">  
      <div class="news__item" @click="viewCard(item.id)" v-for="(item, index) of page.items" :key="index">
        
        <img class="news__preview-image" :src="item.previewPicture != null ? item.previewPicture : require('@/assets/images/no-photo.png')" :alt="item.name">
        <div class="news__item-content">
          <p class="news__item_title custom-title">{{item.name}}</p>
          <p class="date">{{ $momentFormat(item.activeFrom, "DD MMMM YYYY HH:mm") }}</p>
          <p class="news__item_text">{{item.previewText}}</p>
        </div>
      </div>

      <div v-if="page.pagesTotal > 1">
        <Pagination :page-count="page.pagesTotal" :current-page="page.pageNumber" @change="onPageChange($event)"/>
      </div>
      <div>
        <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
      </div>
    </template>
    <template v-if="false">
      <EmptyListMessage/>
    </template>

    <section class="modals">
      <transition name="filter">
        <div class="filter" v-if="modals.filter">
          <NewsPublicFilter v-bind:filters="filter" v-on:apply="onFiltersApply($event)"
                          v-on:reset="onFiltersReset($event)"/>
        </div>
      </transition>
    </section>
  </section>  
</template>
<script>
import API from '@/modules/settings/api/news';
import PageHeader from "@/common/components/page/PageHeader";
import EmptyListMessage from "@/common/components/EmptyListMessage";
import IconComponent from '@/common/ui/IconComponent';
import ButtonComponent from '@/common/ui/ButtonComponent';
import NewsPublicFilter from '@/modules/help/components/NewsPublicFilter'
import PageCounter from "@/common/components/PageCounter";
import Constants from "@/common/constants";

export default {
  name: "NewsPublic",
  components: {
    PageHeader,    
    EmptyListMessage,
    IconComponent,
    ButtonComponent,
    NewsPublicFilter,
    PageCounter
  },
  data() {
    return {
      request: {
        pageNumber: 1,
        pageSize: Constants.pageSize
      },  
      filter: {
        publicationDateFrom: null,
        publicationDateTo: null,
        name: '',
        previewText: '',
        newsStatus: 2
      },    
      page: {}, 
      modals: {
        filter: false
      },
      isFiltered: false,
      totalCount: 0
    }
  },
  created() {    
    const self = this;
    API.searchPublic({ pageNumber: 1, pageSize: 1, newsStatus: this.filter.newsStatus }).then((response) => {
      self.totalCount = response.data.itemsTotal;
    });
    this.loadPage();
  },
  methods: {
    loadPage() {
      let params = Object.assign(this.filter, this.request);
      API.searchPublic(params).then((response) => {
        this.page = response.data;
      });
    },    
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.loadPage()
    },    
    viewCard(id) {
      this.$router.push({name: 'NewsPublicCard', params: {id: id, action: 'view'}})
    },
    onFiltersApply(filters) {
      this.filter = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.isFiltered = true;
      this.loadPage();
      const self = this;
      API.searchPublic({ pageNumber: 1, pageSize: 1, newsStatus: this.filter.newsStatus }).then((response) => {
        self.totalCount = response.data.itemsTotal;
      });
    },
    onFiltersReset(filters) {
      this.filter = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.isFiltered = false;
      this.loadPage();
      const self = this;
      API.searchPublic({ pageNumber: 1, pageSize: 1, newsStatus: this.filter.newsStatus }).then((response) => {
        self.totalCount = response.data.itemsTotal;
      });
    },
  },
}
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.content {
  padding: 32px;
  position: relative;
  overflow-y: visible;

  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity .2s;
  }

  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
}

.date{
  font-weight: 300;
  font-size: 12px;
  line-height: 200%;
  color: #969595;
  margin-bottom: 8px;
}
.news__item{
  cursor: pointer;
  display: flex;
  width: 100%;  
  margin-bottom: 40px;
  img{
    margin-right: 20px;
    max-width: 200px;
    max-height: 200px;
    width: 100%;
    height: 100%;
  }
}
.custom-title{
  height: auto;
  margin-bottom: 0px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 24px;
}

.news__preview-image {
  object-fit: contain;
}

.control-label {
  display: inline-block;
  margin-bottom: 0;
}

.filter-date-edit {
  width: 110px;
}

.filter-edit {
  width: 220px;
}
</style>
